var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { Menu, MenuDropdown } from '../../Menu';
import { Image } from '../../Image';
import { ContactForm } from '../../forms';
import { Flex } from '../../../layout';
import { ButtonSlim, ButtonLink } from '../../buttons';
import defaultAvatarImg from '../../../assets/img/default-avatar.png';
import { Title, PictureWrapper, InfoBlock, InfoBlockTitle, InfoBlockName, InfoBlockItem, RepresentativeTitle, } from './styledComponents';
export var RepresentativeExtendedMenu = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? 'Your Customer Operations Rep.' : _c, _d = _a.infoBlockTitle, infoBlockTitle = _d === void 0 ? 'Your Customer Operations Representative' : _d, _e = _a.customerOpsEmail, customerOpsEmail = _e === void 0 ? '' : _e, subjectOptions = _a.subjectOptions, onMessageSubmit = _a.onMessageSubmit, onClose = _a.onClose, representative = _a.representative, menuProps = __rest(_a, ["isOpen", "title", "infoBlockTitle", "customerOpsEmail", "subjectOptions", "onMessageSubmit", "onClose", "representative"]);
    var _f = useState(false), isContactFormOpen = _f[0], setIsContactFormOpen = _f[1];
    var closeDropdown = function () {
        setIsContactFormOpen(false);
        onClose();
    };
    var handleMessageSubmit = function (_a) {
        var subject = _a.subject, message = _a.message;
        onMessageSubmit({ message: message, subject: subject });
        setIsContactFormOpen(false);
    };
    var renderImage = function () { return (<Image src={representative.userImageUrl || defaultAvatarImg} fallbackSrc={defaultAvatarImg} alt={title}/>); };
    var renderInfoBlock = function () {
        return (<InfoBlock data-testid="info-block">
        <PictureWrapper>{renderImage()}</PictureWrapper>
        <div>
          <InfoBlockTitle>{infoBlockTitle}</InfoBlockTitle>
          {representative.name && <InfoBlockName>{representative.name}</InfoBlockName>}
          <InfoBlockItem>
            <AlternateEmailIcon />
            <a href={"mailto:".concat(customerOpsEmail)}>{customerOpsEmail}</a>
          </InfoBlockItem>
          {representative.workPhone && (<InfoBlockItem>
              <LocalPhoneOutlinedIcon />
              <a href={"tel:".concat(representative.workPhone)}>{representative.workPhone}</a>
            </InfoBlockItem>)}
          {representative.mobilePhone && (<InfoBlockItem>
              <PhoneAndroidOutlinedIcon />
              <a href={"tel:".concat(representative.mobilePhone)}>{representative.mobilePhone}</a>
            </InfoBlockItem>)}
          <div style={{ marginTop: '1rem' }}>
            <ButtonSlim data-testid="contact-btn" onClick={function () { return setIsContactFormOpen(true); }}>
              Contact
            </ButtonSlim>
            <ButtonLink data-testid="cancel-btn" onClick={closeDropdown}>
              Cancel
            </ButtonLink>
          </div>
        </div>
      </InfoBlock>);
    };
    return (<Menu isOpen={isOpen} onClickOutside={closeDropdown} disableFocusRipple {...menuProps}>
      <Flex data-testid="representative-extended-menu">
        <PictureWrapper>{renderImage()}</PictureWrapper>
        <div>
          <Title>{title}</Title>
          {representative.name && <RepresentativeTitle>{representative.name}</RepresentativeTitle>}
        </div>
        <MenuDropdown isOpen={isOpen} data-testid="representative-extended-menu-dropdown">
          {isContactFormOpen ? (<ContactForm subjectOptions={subjectOptions} onSubmit={handleMessageSubmit} onClose={closeDropdown}/>) : (renderInfoBlock())}
        </MenuDropdown>
      </Flex>
    </Menu>);
};
